import { Injectable, NgZone } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApkUploadService {

  constructor(private ngZone: NgZone) {}

  uploadWithProgress(
    url: string,
    formData: FormData,
    onProgress: (pct: number) => void
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) {
          this.ngZone.run(() => onProgress(Math.round((e.loaded / e.total) * 100)));
        }
      });

      xhr.addEventListener('load', () => {
        console.log('📦 Upload response:', xhr.responseText);
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const res  = JSON.parse(xhr.responseText);
            const name = res.file.filename || res.file.originalname || res.fileName || null;
            if (!name) reject(new Error('Could not extract filename'));
            else resolve(name);
          } catch { reject(new Error('Failed to parse upload response')); }
        } else {
          reject(new Error(`Upload failed: HTTP ${xhr.status}`));
        }
      });

      xhr.addEventListener('error', () => reject(new Error('Network error during upload')));
      xhr.addEventListener('abort', () => reject(new Error('Upload aborted')));
      xhr.open('POST', url);
      xhr.send(formData);
    });
  }
}